/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderLightDto } from './ProviderLightDto';
import {
    ProviderLightDtoFromJSON,
    ProviderLightDtoFromJSONTyped,
    ProviderLightDtoToJSON,
    ProviderLightDtoToJSONTyped,
} from './ProviderLightDto';

/**
 * 
 * @export
 * @interface GetProviderPrescriptionFiltersResponseDto
 */
export interface GetProviderPrescriptionFiltersResponseDto {
    /**
     * Statuses
     * @type {Array<string>}
     * @memberof GetProviderPrescriptionFiltersResponseDto
     */
    statuses: Array<GetProviderPrescriptionFiltersResponseDtoStatusesEnum>;
    /**
     * Providers
     * @type {Array<ProviderLightDto>}
     * @memberof GetProviderPrescriptionFiltersResponseDto
     */
    providers: Array<ProviderLightDto>;
}


/**
 * @export
 */
export const GetProviderPrescriptionFiltersResponseDtoStatusesEnum = {
    Cancelled: 'cancelled',
    Paid: 'paid',
    Pending: 'pending'
} as const;
export type GetProviderPrescriptionFiltersResponseDtoStatusesEnum = typeof GetProviderPrescriptionFiltersResponseDtoStatusesEnum[keyof typeof GetProviderPrescriptionFiltersResponseDtoStatusesEnum];


/**
 * Check if a given object implements the GetProviderPrescriptionFiltersResponseDto interface.
 */
export function instanceOfGetProviderPrescriptionFiltersResponseDto(value: object): value is GetProviderPrescriptionFiltersResponseDto {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('providers' in value) || value['providers'] === undefined) return false;
    return true;
}

export function GetProviderPrescriptionFiltersResponseDtoFromJSON(json: any): GetProviderPrescriptionFiltersResponseDto {
    return GetProviderPrescriptionFiltersResponseDtoFromJSONTyped(json, false);
}

export function GetProviderPrescriptionFiltersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProviderPrescriptionFiltersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': json['statuses'],
        'providers': ((json['providers'] as Array<any>).map(ProviderLightDtoFromJSON)),
    };
}

export function GetProviderPrescriptionFiltersResponseDtoToJSON(json: any): GetProviderPrescriptionFiltersResponseDto {
    return GetProviderPrescriptionFiltersResponseDtoToJSONTyped(json, false);
}

export function GetProviderPrescriptionFiltersResponseDtoToJSONTyped(value?: GetProviderPrescriptionFiltersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': value['statuses'],
        'providers': ((value['providers'] as Array<any>).map(ProviderLightDtoToJSON)),
    };
}

